import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import NextIcon from '@material-ui/icons/SkipNext';
import PrevIcon from '@material-ui/icons/SkipPrevious';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { img, staticsUrl } from '../../config';

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
    '& h3': {
      color: theme.palette.primary.main,
    },
  },
  intro: {
    textAlign: 'center',
    '& div': {
      cursor: 'pointer',
      display: 'inline-block',
      borderRadius: '50%',
      backgroundColor: '#fff',
      backgroundSize: 'contain',
      margin: '2%',
      width: '25%',
      paddingBottom: '25%',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.3)',
      border: '0.25em solid #fff',
      transition: 'all 0.3s',
      '&:hover': {
        transform: 'scale(1.1)',
      },
    },
  },
  imgWrap: {
    '& > div': {
      width: '25%',
      paddingBottom: '25%',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.3)',
      border: '0.25em solid #fff',
      margin: '0 auto',
      borderRadius: '50%',
      backgroundSize: 'contain',
    },
  },
  text: {
    textAlign: 'center',
    width: 400,
    padding: '1em',
    borderRadius: '1em',
    border: '3px solid ' + theme.palette.primary.light,
    maxWidth: '100%',
    background: '#fff',
    margin: '20px auto',
  },
  sample: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.main,
    fontFamily: theme.typography.body1.fontFamily,
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  '@media(max-width: 850px)': {
    imgWrap: {
      '& > div': {
        width: '50%',
        paddingBottom: '50%',
      },
    },
    text: {
      padding: '0.5em',
    },
  }
}));

function TalkToMe(props) {
  const classes = useStyles();
  const [ state, setState ] = useState('intro');
  const [ no, setNo ] = useState(0);
  const [ face, setFace ] = useState(1);
  const { exercise, startStats, finishExercise, action, type } = props.exerciseProps;
  const len = exercise.length;

  useEffect(() => {
    init();
    return () => {}
    // eslint-disable-next-line
  }, []);

  const init = () => {
    startStats(type);
  }

  const play = () => {
    action();
    const url = staticsUrl + exercise[no].soundUrl;
    props.media.play(url);
  }

  const next = () => {
    action();
    if (no < len - 1) setNo(no + 1);
    if (no === len - 2) finish();
  }
  const prev = () => {
    if (no > 0) setNo(no - 1);
    action();
  }

  const finish = () => {
    finishExercise();
  }

  const drawIntro = () => {
    const handleClick = no => {
      setFace(no);
      setState('exercise');
    }
    return <div className={classes.intro}>
      <h3>Wybierz osobę do konwersacji</h3>
      <div style={{backgroundImage: `url(${img('face1.png')})`}} onClick={() => handleClick(1)}/>
      <div style={{backgroundImage: `url(${img('face2.png')})`}} onClick={() => handleClick(2)}/>
      <div style={{backgroundImage: `url(${img('face3.png')})`}} onClick={() => handleClick(3)}/>
      <div style={{backgroundImage: `url(${img('face4.png')})`}} onClick={() => handleClick(4)}/>
      <div style={{backgroundImage: `url(${img('face5.png')})`}} onClick={() => handleClick(5)}/>
      <div style={{backgroundImage: `url(${img('face6.png')})`}} onClick={() => handleClick(6)}/>
    </div>
  }

  const drawExercise = () => {
    const imgName = 'face' + face + '.png';
    return <div className={classes.exercise}>
      <div className={classes.imgWrap}>
        <div style={{backgroundImage: `url(${img(imgName)})`}}/>
      </div>
      <div className={classes.text}>
        <p>{exercise[no].text}</p>
        <IconButton onClick={play}>
          <VolumeUpIcon fontSize="large" color="primary"/>
        </IconButton>
      </div>
      <div className={classes.action}>
        <Button variant="outlined" color="secondary" onClick={prev} disabled={no === 0}><PrevIcon /></Button>
        <span>{no + 1}/{len} </span>
        <Button variant="outlined" color="secondary" onClick={next} disabled={no === len - 1}><NextIcon /></Button>
      </div>
    </div>
  }

  return (
    <div className={classes.wrapper}>
      <div>
        {state === 'intro' && drawIntro()}
        {state === 'exercise' && drawExercise()}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps)(TalkToMe);
